// libs
import { NotificationContainer } from "react-notifications";
import React, { useState, useEffect } from "react";

// state
import { UserContext } from "store/user_context";
// components
import AjaxSpinner from "components/commons/ajax_spinner";
import ServerError from "components/commons/server_error";
import Main from "components/main";
// styles
import "react-notifications/lib/notifications.css";
import "scss/auth.scss";
// conf
import conf from "conf/config";
// api
import { AUTH } from "api/account";

// debug for dev
if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  window.$DEBUG = true;
  window.$CONF = conf;
  window.konsole = { log: console.log };
} else {
  window.konsole = { log: (msg) => {} };
}

function App() {
  // states
  const [user_data, set_user_data] = useState(null);
  const [server_error, set_server_error] = useState(null);

  let tmp = new URL(window.location.href);
  const _came_from = tmp.searchParams.has("came_from")
    ? tmp.searchParams.get("came_from")
    : null;

  // Decodifica il valore del parametro 'came_from'
  const came_from_url = _came_from ? decodeURIComponent(_came_from) : null;

  const [came_from] = useState(came_from_url);

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      const response = await AUTH.info();
      if (response.ok) {
        const data = await response.json();
        console.log("main page " + JSON.stringify(data));
        if (mounted) {
          data.came_from = came_from;
          set_user_data(data);
          set_server_error(null);
        }
      } else {
        set_user_data(null);
        set_server_error(response.status);
        console.error("server error");
      }
    };
    // call the function
    fetchData()
      // make sure to catch any error
      .catch(console.error);
    return () => (mounted = false); // cleanup function
  }, [came_from]);

  if (user_data === null) {
    if (server_error !== null) {
      return <ServerError code={server_error} />;
    } else {
      return <AjaxSpinner />;
    }
  } else {
    return (
      <UserContext.Provider value={user_data}>
        <>
          <Main set_user_data={set_user_data} />
          {/* <NotificationContainer/> */}
        </>
      </UserContext.Provider>
    );
  }
}
export default App;
